// export const BASEURL = 'http://gogo-cinemacon.binarynumbers.io';
// export const BASEURL = 'http://gogocinema.binarynumbers.io';
// export const BASEURL = 'https://api.gogocinema.com';
// export const BASEURL = 'http://developmentgogocinema.binarynumbers.io';
// export const BASEURL = 'http://www.yogesh.com';
// export const BASEURL = 'https://api-uat.gogocinema.com';
// export const BASEURL = 'https://gogo-alpha-api.binarynumbers.io';
// export const BASEURL = 'http://13.228.128.234';
// export const BASEURL = 'http://api.gogocinema.com';

var url = process.env.API_URL || "";
var stripePublicKey = "";
if (window.location.host === "test.gogocinema.com") {
  url = "https://api-test-1.binarynumbers.io";
  stripePublicKey = "pk_live_XmcqMGTPozqA2i9zxpyWzcwg004N11eO55";
} else if (window.location.host === "gogocinema.com") {
  url = "https://api-gdc-prod.binarynumbers.io";
  stripePublicKey = "pk_test_ugVaLIFJmaQKYnVc71msZtST00aJhA3Tds";
} else if (window.location.host === "test.gogocinema.com") {
  url = "https://api.gogocinema.com/api";
  stripePublicKey = "pk_live_XmcqMGTPozqA2i9zxpyWzcwg004N11eO55";
} else if (window.location.host === "test-uat.gogocinema.com") {
  url = "https://api-uat.gogocinema.com/api";
  stripePublicKey = "pk_live_XmcqMGTPozqA2i9zxpyWzcwg004N11eO55";
} else if (window.location.hostname == "gogo-1.brij.tech") {
  url = "https://api-gdc-1.brij.tech";
  stripePublicKey = "pk_test_ugVaLIFJmaQKYnVc71msZtST00aJhA3Tds";
} else if (window.location.hostname == "stg.gogocinema.com") {
  url = "https://api-gdc-1.brij.tech";
  stripePublicKey = "pk_test_ugVaLIFJmaQKYnVc71msZtST00aJhA3Tds";
} else if (window.location.hostname == "bnb-prod.gogocinema.com") {
  url = "https://api-gdc-1.brij.tech";
  stripePublicKey = "pk_test_ugVaLIFJmaQKYnVc71msZtST00aJhA3Tds";
} else if (window.location.hostname == "localhost") {
  //url = "http://localhost:3800";
  url = process.env.API_URL || "http://localhost:4200";
  stripePublicKey = "pk_test_ugVaLIFJmaQKYnVc71msZtST00aJhA3Tds";
} else {
  url = process.env.API_URL || "http://developmentgogocinema.binarynumbers.io/api";
  stripePublicKey = "pk_test_ugVaLIFJmaQKYnVc71msZtST00aJhA3Tds";
}
export const ARENA_TOKEN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjYwN2VkY2MwLTNjODQtNGRhZC1hY2VmLTBjN2FhYjNmMzU1MyIsImlhdCI6MTYwNjg5MzA0MCwiZXhwIjoxNjA5NDg1MDQwfQ.3dkWIqaDYXjJ0Eayq_nL8Q0rbmqfYcyI3NLZbcbKh8Y`;
export const BING_TOKEN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjIwNTE5ZGM2LTNkODktNDViMi04OTM5LWM2Yjg4YmM2NmExNSIsImlhdCI6MTYxMjQzNzQzOSwiZXhwIjoxNjE1MDI5NDM5fQ.jMjwQUqQopck_eOQga-zTig3DDhuhnRLMpgSRo2_5s4`;
export const imaculix1 = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjRkMDE4OGIyLTdhNzctNDIzMy1iMjM5LTNlNTkyMmJmYTk3MyIsImlhdCI6MTYxMzIwODE4MSwiZXhwIjoxNjE1ODAwMTgxfQ.ZbFgp541YdJqRvR3P7BrZlLwN2Bv73bdgixWyaIMeBE`;
export const GOGOLIVE = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjdiNjZjZTcxLWE0YmYtNGNjNS1iM2Y5LTYwMzA5ZDhhZTI0ZCIsImlhdCI6MTYyODA2NDYxMSwiZXhwIjoxNjMwNjU2NjExfQ.Ulkr2mY0ZpE6-dTIa8O8abx2ETegjXxfJpl8ODFxN4E`;
export const cinema_Akil_dump1 = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImU0YmMxZmMzLWYyZmYtNDdiYy05OTQyLWQxZTE5NzZhYjZiOSIsImlhdCI6MTYyMjQ2ODQ2NCwiZXhwIjoxNjg1NTIwNjY1fQ.EYaseltsTkWgUbkW3ug0qPgoYb0yneodvYWS0deGbvo`;
export const GOGOLIVENEW = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjZhNmU2YjIzLTZmN2EtNDdmZS05Y2U3LWE3NDA0ZDJiYmJmYSIsImlhdCI6MTYzMTE5MjYzMSwiZXhwIjoxNjMzNzg0NjMxfQ.-Nw28gtaV7m43ztlzKdZZn-9L95l28o30xo9GQuqrvo`;
//export const GOGOTEST = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjI2NzYzYzI3LTMzNjYtNDUzZS1hYWI2LTdkYjhkZWIwM2VjMSIsImlhdCI6MTYzODg3Nzc1NSwiZXhwIjoxNjQxNDY5NzU1fQ.xyiMlGWwaacTrswZFQFPSUCj4L6HrgJtmQqEVhKaMEU`;
export const GOGOTEST = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjdmYWExODNhLTMxOTctNDIxZS1iZDJkLTA3YTVlYjRlNjEwOCIsImlhdCI6MTYzODg3ODY4OSwiZXhwIjoxNjQxNDcwNjg5fQ.QoUmCOkmWq8xgs7kLKQCjZYsWhIrbxmHnNCxt6o-gw8'
export const TOKEN = GOGOLIVE;
export const URL_BASE = url;
export const STRIPE_PUBLIC_KEY = stripePublicKey;
export const PROJECT_TITLE = "GoGoCinema";
export const LIMIT = "90";



// WEBPACK FOOTER //
// ./src/helper/constants.js